/** Labels for data scope and freshness derived from API payloads (not hardcoded dates). */

export const formatDataFreshnessLabel = (isoDate) => {
  if (!isoDate) return null;
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return null;
  const now = new Date();
  const sameDay =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();
  const time = date.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  return sameDay
    ? `Updated today · ${time}`
    : `Updated ${date.toLocaleDateString("en-IN")} · ${time}`;
};

export const formatGeneratedDate = (isoDate) => {
  const label = formatDataFreshnessLabel(isoDate);
  if (label) return label;
  if (!isoDate) return null;
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

export const buildScopeDataLabel = (overview = {}) => {
  const schools = overview.total_schools ?? overview.schools_with_remarks ?? 0;
  const students =
    overview.total_students ??
    overview.grand_total ??
    overview.total_enrolment ??
    overview.total_remarks ??
    0;
  const blocks = overview.total_blocks ?? 0;

  if (schools > 0 && students > 0) {
    return `${schools.toLocaleString("en-IN")} schools · ${students.toLocaleString("en-IN")} records`;
  }
  if (schools > 0) return `${schools.toLocaleString("en-IN")} schools in scope`;
  if (students > 0) return `${students.toLocaleString("en-IN")} records loaded`;
  if (blocks > 0) return `${blocks.toLocaleString("en-IN")} blocks in scope`;
  return "Scope data loaded";
};

export const buildDataStatusChip = (overview = {}, generatedAt = null) => {
  const freshness = formatDataFreshnessLabel(generatedAt);
  return freshness || buildScopeDataLabel(overview);
};
